// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"8d283823","230":"1af8cc15","533":"966d960a","739":"60fc10b3","856":"61cd0a1a","904":"4d39b8ce","951":"b17937d1"}[chunkId] + ".chunk.js";
};